import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import gettext from '@eb/gettext';
import { Badge } from '@eb/eds-badge';
import { Avatar } from '@eb/eds-avatar';
import { CheckChunky } from '@eb/eds-iconography';
import { POSITION_LEFT } from '@eb/eds-badge';

import CollectionSummary from './CollectionSummary';
import ConditionalComponent from './ConditionalComponent';

import './pageHeader.scss';

export const CreatorDisplay = ({ name, imageUrl, isQuality }) => {
    const creatorImage = (
        <Avatar text={name} imageUrl={imageUrl} size="small" />
    );
    const showQualityCreatorImage = isQuality && imageUrl;

    return (
        <section className="user-collection__creator">
            {!showQualityCreatorImage && creatorImage}
            {showQualityCreatorImage && (
                <Badge
                    iconType={<CheckChunky />}
                    bgColor="primary-brand--hover"
                    position={POSITION_LEFT}
                >
                    {creatorImage}
                </Badge>
            )}
            <div
                className={classnames(
                    'eds-l-mar-left-3',
                    'eds-text-bl',
                    'eds-text-color--ui-600',
                    'eds-text-weight--regular',
                )}
            >
                {gettext('Collection by %(name)s', { name })}
            </div>
        </section>
    );
};

const HEADER_SPACING_CLASSES = `
    eds-l-mn-mar-hor-8
    eds-l-mn-mar-vert-12
    eds-l-md-mar-hor-8
    eds-l-md-mar-vert-12
    eds-l-mw-mar-hor-8
    eds-l-mw-mar-vert-12
    eds-l-ln-mar-hor-8
    eds-l-ln-mar-vert-12
    eds-l-lg-mar-hor-12
    eds-l-lg-mar-vert-16
    eds-l-lw-mar-hor-12
    eds-l-lw-mar-vert-16
`;

export default class PageHeader extends PureComponent {
    static propTypes = {
        collectionName: PropTypes.string,
        collectionSummary: PropTypes.string,
        displayCreatorName: PropTypes.string,
        displayCreatorDescription: PropTypes.string,
        creatorName: PropTypes.string,
        creatorImage: PropTypes.string,
        isQuality: PropTypes.bool,
        isEditMode: PropTypes.bool.isRequired,
        followCTANode: PropTypes.node,
    };

    render() {
        const {
            isQuality,
            isEditMode,
            creatorName,
            creatorImage,
            followCTANode,
            collectionName,
            collectionSummary,
            displayCreatorName,
            displayCreatorDescription,
            ownerActionBarNode,
            collectionImageUrl,
            isOwner,
        } = this.props;

        const nameToUse = displayCreatorName || creatorName;
        const isImageSet = !!collectionImageUrl;

        return (
            <section
                className={classnames(
                    'user-collection__header',
                    { 'user-collection__header--has-image': isImageSet },
                    'eds-l-sn-mar-top-6',
                    'eds-l-sm-mar-top-6',
                    'eds-l-sw-mar-top-6',
                    'eds-g-cell-mn-6-12',
                    'eds-g-cell-md-5-12',
                )}
            >
                <div
                    className={classnames({
                        [HEADER_SPACING_CLASSES]: isImageSet,
                    })}
                >
                    <div
                        className={classnames({
                            'eds-g-cell-mn-8-12': !isImageSet,
                        })}
                    >
                        <header className="eds-text-hl eds-hide-mn eds-hide-md eds-hide-mw eds-hide-ln">
                            {collectionName}
                        </header>
                        <header className="eds-text-hm eds-hide-sn eds-hide-sm eds-hide-sw eds-hide-lg eds-hide-lw">
                            {collectionName}
                        </header>
                    </div>
                    <div
                        className={classnames({
                            'user-collection__header--has-max-width': !isImageSet,
                        })}
                    >
                        <div className="user-collection__header-separator eds-l-mar-vert-8" />
                        <div className="eds-l-mar-vert-4">
                            {nameToUse && (
                                <CreatorDisplay
                                    name={nameToUse}
                                    imageUrl={creatorImage}
                                    isQuality={isQuality}
                                    displayCreatorDescription={
                                        displayCreatorDescription
                                    }
                                />
                            )}
                        </div>
                        <ConditionalComponent
                            shouldRender={displayCreatorDescription}
                        >
                            <div className="eds-l-mar-vert-4">
                                {displayCreatorDescription}
                            </div>
                        </ConditionalComponent>
                        <div className="eds-show-up-mn eds-l-mar-vert-8">
                            <CollectionSummary
                                collectionSummary={collectionSummary}
                                isEditMode={isEditMode}
                            />
                        </div>
                        <div className="eds-show-up-mn">
                            {isOwner ? ownerActionBarNode : followCTANode}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
